export default {
  translation: {
    //////////  TOP MENU //////////
    topMenu: {
      signin: 'Inloggen',
      about: 'over ons',
      support: 'Ondersteuning',
      newsResources: 'Nieuws en Research',
    },

    ////////// BOTTOM MENU //////////
    bottomMenu: {
      plans: 'Prijzen',
      product: 'Product',
      contact: 'Contact',
      freeTrial: 'Free trial',
      allPricesInAUD: 'Alle prijzen in Australische dollars',
      allPricesInUS: 'Alle prijzen in Amerikaanse dollars',
      allPricesInEUR: 'Alle prijzen in Euros',
      allPricesInGBP: 'Alle prijzen in GBP',
      termsText: 'Door het downloaden van Eyetelligence Software gaat u akkoord met de ',
      privatePolicy: 'Privacy Policy',
      and: 'en de',
      termsCondition: 'Algemene Voorwaarden'
    },

    ////////// SIGN IN //////////
    signin: {
      login: 'Log in',
      title: 'Log in om toegang te krijgen tot uw Eyetelligence Assure account.',
      forgotPassword: 'Wachtwoord vergeten?',
      freeTrial: 'Geen account? Start uw gratis proefperiode.',
      inputLabel1: 'Email',
      inputLabel2: 'Wachtwoord',
    },

    ////////// SIGN UP //////////
    signup: {
      clinic: {
        firstStep: {
          title: 'Welkom',
          desc:
            'Gelieve ons de volgende gegevens te verstrekken om een passende aanbieding te maken.',
          inputLabel1: 'Naam van de winkel of kliniek',
          inputLabel2: 'Uw functie',
          inputLabel3: "Aantal fundus camera's",
        },
        thirdStep: {
          title: 'Uw order',
          planType: 'Licentie keuze',
          freeTrial: 'Gratis 30 dagen proberen',
          buttonText: 'Start uw gratis proefperiode',
        },
        fourStep: {
          title: 'Bijna klaar.',
          desc: 'Controleer uw inbox. We hebben u een e-mail gestuurd met een verificatielink.',
        },
      },
      company: {
        firstStep: {
          title: 'We hebben nog een paar gegevens nodig',
          desc:
            'Gelieve ons de volgende gegevens te verstrekken om een passende aanbieding te maken.',
          inputLabel1: 'Naam van de winkel of kliniek',
          inputLabel2: 'Uw functie',
          inputLabel3: 'Land',
          inputLabel4: 'Hoeveel winkels?',
          inputLabel5: 'Maakt u gebruik van een centraal IT systeem?',
          inputLabel6: 'Ja',
          inputLabel7: 'Nee',
          buttonText: 'Ga door',
        },
        thirdStep: {
          title: 'Bevestig uw gegevens',
          desc: 'Controleer de onderstaande gegevens en controleer of alles correct is',
          looksGood: 'Ziet er goed uit',
        },
        fourStep: {
          title: 'Dank U!',
          desc:
            'Ons team neemt spoedig contact met u op om de gratis proefperiode van 30 dagen in te stellen.',
        },
      },
      secondStep: {
        title: 'We hebben nog een paar gegevens van u nodig',
        desc:
          'We gebruiken deze informatie om uw gratis proefperiode in te stellen en uw account aan te passen.',
        accountLink: 'Heeft u al een acсount?',
        inputLabel1: 'Uw volledige naam',
        inputLabel2: 'Telefoonnummer (facultatief)',
        inputLabel3: 'E-mail',
        inputLabel4: 'Wachtwoord aanmaken (min 6 max 64)',
        inputLabel5: 'Bevestiging wachtwoord aanmaken',
      },
      infoBlock: {
        yourName: 'Uw naam',
        yourPosition: 'Uw functie',
        email: 'E-mail',
        phone: 'Telefoon',
        companyName: 'Bedrijfsnaam',
        clinicName: 'Naam kliniek',
        numberOf: 'Aantal',
        clinics: 'Stores',
        computers: 'computers',
      },
    },

    ////////// CONFIRM REGISTER //////////
    confirmSuccess: {
      title: 'Succes!',
      desc:
        'Uw e-mail is geverifieerd. Ga verder naar de volgende pagina om het aanmeldproces te voltooien en te beginnen met het downloaden van uw gratis proefversie.',
    },

    ////////// RESET PASSWORD //////////
    resetPassword: {
      title: 'Wijzig Wachtwoord',
      mistmatch: 'Wachtwoord niet overeengekomen',
      inputLabel1: 'Huidig wachtwoord',
      inputLabel2: 'Nieuw Wachtwoord',
      inputLabel3: 'Nieuw wachtwoord herhalen',
      buttonText: 'Wijzigingen opslaan',
    },

    ////////// FORGOT PASSWORD //////////
    forgotPassword: {
      title: 'Forgot password?',
      forgotPassword: 'Forgot password?',
      resetPassword: 'Reset Password',
      freeTrial: 'No account? Start your free trial.',
      inputLabel1: 'Email',
      inputLabel2: 'Password',
    },

    ////////// CREATE NEW PASSWORD //////////
    createNewPassword: {
      title: 'Create new password',
      inputLabel1: 'Create new password',
      inputLabel2: 'Сonfirm new password',
      buttonText: 'Confirm',
    },

    ////////// SIGN UP CLINICS //////////
    signupClinics: {
      title: 'Aanmelden voor Eyetelligence',
      inputLabel1: 'Volledige naam',
      inputLabel2: 'E-mail',
      inputLabel3: 'Wachtwoord',
      inputLabel4: 'Mobiel nummer',
      inputLabel5: 'Bedrijfsnaam',
      inputLabel6: 'Winkel locatie',
      inputLabel7: 'Telefoon winkel',
      buttonText: 'Gereed',
    },

    ////////// GENERAL //////////
    general: {
      backToDashboard: 'TERUG NAAR DASHBOARD',
      backToLicence: 'TERUG NAAR LICENTIE',
      backToLogin: '< Terug naar Inloggen',
      step: 'Stap',
      of: 'van',
      edit: 'EDIT',
      hi: 'Hallo',
      loading: 'Bezig met laden',
      continue: 'Ga door',
    },

    ////////// DASHBOARD //////////
    dashboard: {
      yourCurrentPlan: 'Uw huidige plan',
      expired: 'Verlopen',
      startedfrom: 'Begonnen vanaf',
      nextBillableDate: 'Volgende factureerbare datum',
      youHave: 'U heeft',
      licences: 'licenties',
      manageLicences: 'Licenties beheren',
      billingHistory: 'Factureringsgeschiedenis',
      receipt: 'Ontkoppelen',
      youHaveNoBillingHistory: 'U hebt geen factureringsgeschiedenis...',
      accountInformation: 'Accountinformatie',
      name: 'Naam',
      email: 'E-mail',
      phone: 'Telefoon',
      clinicName: 'Winkelnaam',
      yourPosition: 'Uw Positie',
      passwordDetails: 'Wachtwoord details',
      creditCardDetails: 'Credit Card Details',
      clickCounter: 'Klik teller',
      change: 'WIJZIGEN',
      contactUs: 'Contacteer Ons',
      pleaseClick: 'Klik aub',
      here: 'hier',
      help: 'als u hulp nodig heeft met uw account of Eyetelligence producten',
      activetedCamera: 'Camera is met succes geactiveerd',
      deactivatedCamera: 'Camera is met succes gedeactiveerd',
      cahgedNickname: 'Camera bijnaam succesvol gewijzigd',
    },

    ////////// ENTERPRISE PLAN //////////
    enterprisePlan: {
      freeTrial: 'Uw 30-dagen gratis proefversie van Eyetelligence Assure is afgelopen.',
      desc:
        'Uw proefperiode is nu verlopen, maar geen zorgen. U kunt doorgaan met het benutten van de krachtige voordelen van AI voor uw patiënten. Een van onze teamleden zal contact met u opnemen om de volgende stappen te bespreken, of u kunt contact opnemen via de onderstaande e-mail.',
      contactUs: 'Contacteer ons',
      email: 'E-mail',
      mail: 'Mail',
      street: 'Diefhoekstraat 8',
      city: '4727 SV Moerstraten',
      chat: 'Laten we chatten',
      description:
        'Neem vandaag nog contact op met ons team. Wij zijn er om u te helpen en staan klaar om uw vragen en verzoeken te beantwoorden.',
      loading: 'Loading',
    },

    ////////// LICENCE //////////
    licence: {
      isDelete: 'Weet u zeker dat u het huidige plan wilt annuleren?',
      newNname: 'Nieuwe naam',
      maxCharacters: 'Max 32 tekens',
      minCharacters: 'Min 1 karakter',
      yourLicenceSummary: 'Uw licentie samenvatting',
      cancelPlan: 'Plan annuleren',
      computerID: 'Computer ID',
      activationCode: 'Activeringscode',
      validDate: 'Geldige datum',
      activate: 'Activeer',
      revoke: 'Ontkoppelen',
      number: 'Nummer',
      nickname: 'Bijnaam',
      status: 'St',
      active: 'Ac',
      inactive: 'Inactief',
      needLicence: 'Heb een licentie nodig',
      upgradePlan: 'Upgrade plan',
      cancelPlanPopup: 'Weet je zeker dat je dit abonnement wilt annuleren?'
    },

    ////////// PLAN //////////
    plan: {
      cardDetails: 'Kaartgegevens',
      pay: 'Betalen',
      title: 'Overzicht bestelling',
      planType: 'Type plan',
      annual: 'Jaarlijks',
      annually: 'Jaarlijks (Betaal jaarlijks en bespaar 10%)',
      monthly: 'Maandelijks',
      payPerClick: 'Betaal per klik',
      freeTrial: 'Gratis 30 dagen proefperiode',
      eachYear:
        'Wordt elk jaar automatisch gefactureerd. U kunt uw plan of factureringsgegevens bewerken via uw accountdashboard. U kunt de betaling van uw abonnement op elk gewenst moment annuleren. De resterende dagen van uw abonnement zullen u als terugbetaling worden verstrekt.',
      eachMonth:
        'Automatisch elke maand gefactureerd. U kunt uw plan of factureringsgegevens bewerken via uw accountdashboard. U kunt de betaling van uw abonnement op elk gewenst moment annuleren. De resterende dagen van uw abonnement zullen u als terugbetaling worden verstrekt.',
      updateCurrentPlan: 'Huidig plan bijwerken',
      addCard: 'Kaart toevoegen',
      successfullyUpdated: 'Succesvol bijgewerkt',
      computerHaveInternet: 'Hebben de computers in uw praktijk toegang tot internet?',
      yes: 'ja',
      no: 'nee',
    },

    ////////// UPGRADE PLAN //////////
    upgradePlan: {
        upTo: 'Tot',
        upToSmall: 'tot',
        upToLowerCase: 'tot',
        cameras: 'camera\'s',
        specialOffer: 'Speciale aanbieding',
      month: 'maand',
      monthUppCase: 'maand',
      monthShort: 'mo',
      mainTitle: 'Eyetelligence Assure prijzen',
      mainSubTitle: 'Tijd om deze samenwerking officieel te maken. Selecteer hieronder uw licentie en blijf profiteren van alle voordelen van Eyetelligence Assure. \n' +
          '\n' +
          'Hulp nodig bij het kiezen van een abonnement? Neem contact op met ons team om de licentie te vinden dat bij u past.',
      freeTrial: 'Uw 30-dagen gratis proefversie van Eyetelligence Assure is afgelopen.',
      timeToMake:
        'Tijd om deze samenwerking officieel te maken. Selecteer hieronder uw Licentie plan en blijf profiteren van alle voordelen van Eyetelligence Assure.',
      needHelp:
        'Prijzen zijn per camera, per maand, opzeggen op elk moment. Gratis een maand op proef voor alle plannen. Elk plan bevat een gratis 30 dagen proefversie. Geen creditcard nodig. Probeer het nu.',
      chooseThePlan: 'kies de licentie die bij u past',
      single: 'Single',
      cameraLicence: 'Camera-Licentie',
      annuallySave: 'Jaarlijks gefactureerd, bespaar',
      multipleSave: 'Per camera, jaarlijks gefactureerd, bespaar',
      orPay: 'Of betaal',
      billedMonthlyMultiple: 'per camera, maandelijks gefactureerd',
      billedMonthly: 'maandelijks per camera',
      multiple: 'Meerdere',
      cameraLicences: 'Camera-Licenties',
      perCamera: 'Per camera, maandelijks gefactureerd, bespaar',
      perCameraShort: 'Per camera, maandelijks gefactureerd, bespaar',
      perAnalysis: 'per analyse',
      enterprise: 'Enterprise',
      youHaveSix:
        "Als u zes camera's of meer heeft, helpen we u graag met het op maat maken van een plan en eventuele eisen, zodat u de juiste oplossing voor uw team krijgt.",
      select: 'Selecteer Plan',
      FAQ: 'FAQ',
      FAQ1Title: 'Moet ik me vastleggen voor een jaarplan?',
      FAQ1Desc:
        'Nee, we bieden zowel maandelijkse als jaarlijkse plannen aan. Jaarplannen worden vooraf gefactureerd (de maandprijs wordt ter vergelijking getoond). Als u een jaarplan kiest, krijgt u orting op uw licentie.',
      FAQ2Title: 'Kan ik mijn licentie wijzigen?',
      FAQ2Desc:
        'Ja, u kunt uw licentie op elk moment upgraden, downgraden of annuleren via uw accountdashboard.',
      FAQ3Title: 'Wat is het annuleringsbeleid?',
      FAQ3Desc:
        'U kunt uw licentie op elk gewenst moment annuleren via uw accountdashboard. Eenmaal geannuleerd zult u niet in rekening worden gebracht bij uw volgende factureringsperiode. U zult toegang hebben tot Eyetelligence Assure voor de rest van uw factureringsperiode. Voor de resterende tijd wordt geen restitutie verleend.',
      chat: 'Laten we chatten',
      getInTouch:
        'Neem vandaag nog contact op met ons team. We zijn hier om uw vragen en verzoeken te beantwoorden.',
      getInTouchButton: 'Neem contact op',
    },

    ////////// PROFILE //////////
    profile: {
      title: 'Account Informatie',
      clinicName: 'Naam van de zaak',
      yourPosition: 'Uw functie',
      yourFullName: 'Uw volledige naam',
      phoneNumber: 'Telefoonnummer',
      email: 'Email',
      saveChanges: 'Wijzigingen opslaan',
    },
    creditCard: {
      title: 'Credit cards details',
      delete: 'Delete',
    },
    updateUserData: {
      updateUserInfo: 'Uw gegevens zijn succesvol bijgewerkt',
      passwordUpdate: 'Wachtwoord is succesvol bijgewerkt',
      cardAdded: 'Uw kaart is toegevoegd',
      cardDelete: 'Uw kaart is verwijderd',
    },

    ////////// AUTH //////////
    auth: {
      linkSent: 'Link verzonden naar e-mail',
      passwordReset: 'Uw wachtwoord is succesvol gereset',
    },
  },
};
